<script>
import axios from 'axios';
import AS from '@/services/AuthenticationService';
import { get } from 'lodash';

export default {
  approveDocument(payload) {
    const document = get(payload, 'document');
    const application = get(payload, 'application');
    const config = AS.getDefaultHeaders();
    return axios.get(
      `admin/requerimentos/${application.id}/documents/${document.id}/approve`,
      config,
    );
  },
  disapproveDocument(payload) {
    const document = get(payload, 'document');
    const application = get(payload, 'application');
    const refusalReason = get(payload, 'refusalReason');
    const config = AS.getDefaultHeaders();
    return axios.post(`admin/requerimentos/${application.id}/documents/${document.id}/disapprove`,
      { refusal_reason: refusalReason },
      config,
    );
  },
  fetchDocumentTypes() {
    return axios.get('document_types', AS.getDefaultHeaders());
  },
  undoAnalysis(documentId, applicationId) {
    return axios.patch(`admin/requerimentos/${applicationId}/undo_analysis`,
      { id: documentId },
      AS.getDefaultHeaders(),
    );
  },
};
</script>
